import { get } from "~/lib/helpers/objects";
import {createAuthListener} from "~/modules/auth/store";

export default {
  state: {
    data: null
  },
  getters: {
    functionalities: state => path => {
      if (path) return get(state.data, path);
      return state.data;
    }
  },
  mutations: {
    setFunctionalities: (state, functionalities) => {
      state.data = { ...functionalities };
    },
    clearFunctionalities: state => {
      state.data = null;
    }
  },

  actions: {
    storeInit(store){
      createAuthListener({
        onLogin: event => {
          store.commit("setFunctionalities", event.detail.functionalities);
        },
        onLogout: () => store.commit("clearFunctionalities")
      });
    }
  }
};
